// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.property.LeasingPropertyWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingPropertyWebApiHandler_getApplicantsForProperty,
  LeasingPropertyWebApiHandler_getApplicantsForProperty_Path,
  LeasingPropertyWebApiHandler_getLeaseSupportForProperty,
  LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Path,
  LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty,
  LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Path,
  LeasingPropertyWebApiHandler_getPropertyInfo,
  LeasingPropertyWebApiHandler_getPropertyInfo_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetApplicantsForPropertyWebApiResponseDto,
  GetLeaseSupportForPropertyWebApiResponseDto,
  GetPropertyInfoResponseDto,
  LeasingGetLeasesPaginatedResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-leasing-client';

interface GetApplicantsForPropertyParams {
  propertyId: string;
}
interface GetLeaseSupportForPropertyParams {
  propertyId: string;
}
interface GetPaginatedLeasesForLandlordPropertyParams {
  listingAlias: ListingAlias;
  numResults: number;
  offset: number;
}
interface GetPropertyInfoParams {
  propertyId: string;
}

export type LeasingPropertyWebApiHandler_getApplicantsForProperty_Options = UseQueryOptions<
  GetApplicantsForPropertyWebApiResponseDto,
  unknown,
  GetApplicantsForPropertyWebApiResponseDto,
  Array<string | GetApplicantsForPropertyParams>
>;

const LeasingPropertyWebApiHandler_getApplicantsForProperty_GetKey = (getParams: GetApplicantsForPropertyParams) => [
  LeasingPropertyWebApiHandler_getApplicantsForProperty_Path,
  getParams,
];

/**
 * get property applicants
 */
export const useLeasingPropertyWebApiHandler_getApplicantsForProperty = (
  getParams: GetApplicantsForPropertyParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getApplicantsForProperty_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingPropertyWebApiHandler_getApplicantsForProperty_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getApplicantsForProperty(getParams, httpClient),
  });
};
useLeasingPropertyWebApiHandler_getApplicantsForProperty.getKey =
  LeasingPropertyWebApiHandler_getApplicantsForProperty_GetKey;

export type LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Options = UseQueryOptions<
  GetLeaseSupportForPropertyWebApiResponseDto,
  unknown,
  GetLeaseSupportForPropertyWebApiResponseDto,
  Array<string | GetLeaseSupportForPropertyParams>
>;

const LeasingPropertyWebApiHandler_getLeaseSupportForProperty_GetKey = (
  getParams: GetLeaseSupportForPropertyParams,
) => [LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Path, getParams];

/**
 * get the geography name and explainer lease for a property
 */
export const useLeasingPropertyWebApiHandler_getLeaseSupportForProperty = (
  getParams: GetLeaseSupportForPropertyParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingPropertyWebApiHandler_getLeaseSupportForProperty_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getLeaseSupportForProperty(getParams, httpClient),
  });
};
useLeasingPropertyWebApiHandler_getLeaseSupportForProperty.getKey =
  LeasingPropertyWebApiHandler_getLeaseSupportForProperty_GetKey;

export type LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Options = UseQueryOptions<
  LeasingGetLeasesPaginatedResponseDto,
  unknown,
  LeasingGetLeasesPaginatedResponseDto,
  Array<string | GetPaginatedLeasesForLandlordPropertyParams>
>;

const LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_GetKey = (
  getParams: GetPaginatedLeasesForLandlordPropertyParams,
) => [LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Path, getParams];

/**
 * get all leases for property with message and signing by listing alias
 */
export const useLeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty = (
  getParams: GetPaginatedLeasesForLandlordPropertyParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty(getParams, httpClient),
  });
};
useLeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty.getKey =
  LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_GetKey;

export type LeasingPropertyWebApiHandler_getPropertyInfo_Options = UseQueryOptions<
  GetPropertyInfoResponseDto,
  unknown,
  GetPropertyInfoResponseDto,
  Array<string | GetPropertyInfoParams>
>;

const LeasingPropertyWebApiHandler_getPropertyInfo_GetKey = (getParams: GetPropertyInfoParams) => [
  LeasingPropertyWebApiHandler_getPropertyInfo_Path,
  getParams,
];

/**
 * get property data for listing
 */
export const useLeasingPropertyWebApiHandler_getPropertyInfo = (
  getParams: GetPropertyInfoParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyWebApiHandler_getPropertyInfo_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingPropertyWebApiHandler_getPropertyInfo_GetKey(getParams),
    queryFn: () => LeasingPropertyWebApiHandler_getPropertyInfo(getParams, httpClient),
  });
};
useLeasingPropertyWebApiHandler_getPropertyInfo.getKey = LeasingPropertyWebApiHandler_getPropertyInfo_GetKey;
